import {Department} from '@app/core/models/department.model';
import {Integration} from '@app/core/models/integration.model';
import {IQMTimePeriod} from '@app/modules/home/modules/payment/components/new-salary-export/components/select-period/select-period.component';
import {IQOSelectData} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-select-data';
import {Group} from '@app/core/models/group.model';
import {User} from '@app/core/models/user.model';
import {IQMDepartmentWithUsers} from '@app/core/store/actions/new-salary-export.actions';
import {QMIntegration} from '@app/core/models/QMIntegration.model';
import {IPaymentPeriod, IUserTotalCalcWithDepartment} from '@app/core/interfaces/salary';
import {IShiftCount} from '@app/core/interfaces/shiftCount';

export interface INewSalaryExportState {
	selectedTimePeriod: IQMTimePeriod;

	availableDepartments: Department[];
	selectedDepartment: IQOSelectData<Department>;

	availableGroups: Group[];
	selectedUsers: IQOSelectData<User>[];

	availableExportTypes: Integration[];
	selectedExportTypes: Integration[];

	selectedDepartmentsWithUsers: IQMDepartmentWithUsers[];

	selectedIntegration: IQOSelectData<QMIntegration>;
	availableIntegrations: QMIntegration[];
	savedIntegrations: QMIntegration[];

	shiftCount: IShiftCount;

	shiftCalculations: IUserTotalCalcWithDepartment[] | null;
	shiftCalculation: IUserTotalCalcWithDepartment | null;

	paymentPeriods: IPaymentPeriod[] | null;

	selectedYear: number;
	selectedMonth: number;

	isLoading: boolean;
	isLoadingCalculation: boolean;
}

export const initialNewSalaryExportState: INewSalaryExportState = {
	selectedTimePeriod: null,

	availableDepartments: [],
	selectedDepartment: null,

	availableGroups: [],
	selectedUsers: [],

	availableExportTypes: [],
	selectedExportTypes: [],

	selectedDepartmentsWithUsers: [],

	selectedIntegration: null,
	availableIntegrations: [],
	savedIntegrations: [],

	shiftCount: null,

	shiftCalculations: null,
	shiftCalculation: null,

	paymentPeriods: null,

	selectedYear: (new Date()).getFullYear(),
	selectedMonth: (new Date()).getMonth() + 1,

	isLoading: false,
	isLoadingCalculation: false,
};
